import React, {Component} from 'react';
import {connect} from 'react-redux';
import {message} from 'antd';

import Branch from './Branch';
import {storeBranch, updateBranch, fetchBranches} from '../../actions';

class BranchContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            serverErrors: null
        }
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        const {branch} = nextProps;
        if (!branch) return null;

        if (branch.error) {
            return {serverErrors: branch.error}
        }
        if (!branch.error && prevState.serverErrors) {
            return {serverErrors: null}
        }
        return null;
    }
    static notifySuccess() {
        message.success('Successfully updated');
    }
    static notifyError(errors) {
        const errs = typeof errors === 'string' ? errors : Object.keys(errors).map(key => errors[key].map((e, i) => <span key={i}>{e}</span>));
        message.error(errs);
    }
    handlePostSubmit() {
        const {state: {serverErrors}, props: {history}} = this;
        if (!serverErrors) {
            BranchContainer.notifySuccess();
            setTimeout(() => history.goBack(), 100);
            return;
        }

        const {res: {errors, message}} = serverErrors;
        BranchContainer.notifyError(errors || message);
    }
    componentDidMount() {
        const {match: {params: {branch: id}}, landlord, fetchBranches, branch} = this.props;
        if (!id) return;

        return !branch && fetchBranches(landlord);
    }
    render() {
        const {storeBranch, updateBranch, landlord, history, branch} = this.props;
        const onSubmit = (values) => {
            const fn = !branch || branch.draft ? storeBranch : updateBranch;
            const args = !branch || branch.draft ? [landlord, values] : [landlord, branch.id, {...values, id: branch.id}];
            return fn(...args).then(() => this.handlePostSubmit(values));
        };

        return <Branch branch={branch} onSubmit={onSubmit} onCancel={() => history.goBack()}/>;
    }
}

const mapStateToProps = (state, ownProps) => {
    // id exists for edit component
    const {match: {params: {branch: id}}} = ownProps;
    const branch = state.landlord.branches.data.find(b => id ? (b.id === +id) : b.draft);
    return {
        landlord: state.me.application.id,
        branch
    };
};
export default connect(mapStateToProps, {
    storeBranch,
    updateBranch,
    fetchBranches
})(BranchContainer);


// WEBPACK FOOTER //
// ./resources/assets/js/components/provider/BranchContainer.js